export const UNCATEGORISED_SERVICE_CATEGORY = 'Uncategorised';

export interface CategorisableService {
  name: string;
  categoryName?: string | null;
}

export interface ServiceCategoryGroup<T extends CategorisableService> {
  categoryName: string;
  services: T[];
}

/** Group services in stable first-seen order, including older scan snapshots. */
export function groupServicesByCategory<T extends CategorisableService>(
  services: readonly T[]
): ServiceCategoryGroup<T>[] {
  const groups = new Map<string, ServiceCategoryGroup<T>>();

  for (const service of services) {
    const categoryName =
      service.categoryName?.trim().replace(/\s+/g, ' ') ||
      UNCATEGORISED_SERVICE_CATEGORY;
    const key = categoryName.toLowerCase();
    const group = groups.get(key);
    if (group) {
      group.services.push(service);
    } else {
      groups.set(key, { categoryName, services: [service] });
    }
  }

  return [...groups.values()];
}
